import { format, parseISO } from 'date-fns';
import { Report } from 'src/types/Report';
import {
  ReportDisplayStatus,
  transformReportStatusModelToUI,
} from 'src/components/enterprise/features/Reporting/ManageReportsPage/components/ReportStatusIcon/ReportStatusIcon.utils';

const DISPLAY_FORMAT = 'MM/dd/yyyy';

export interface ReportUI {
  exportId: string;
  displayStatus: ReportDisplayStatus;
  exportName: string;
  requestedDate: string;
  reportDisplayName: string;
  dateRange: string;
}

const transformReportDateModelToUI = (dateString: string): string => {
  try {
    return format(parseISO(dateString), DISPLAY_FORMAT);
  } catch {
    return dateString;
  }
};

export const transformReportRequestedAtModelToUI = (
  requestedAt: string
): string => transformReportDateModelToUI(requestedAt);

export const transformReportDateRangeModelToUI = (
  startDate: string,
  endDate: string
): string =>
  `${transformReportDateModelToUI(startDate)} - ${transformReportDateModelToUI(
    endDate
  )}`;

export const transformReportModelToUI = (report: Report): ReportUI => {
  return {
    exportId: report.exportId,
    displayStatus: transformReportStatusModelToUI(report),
    exportName: report.exportName,
    requestedDate: transformReportRequestedAtModelToUI(report.requestedAt),
    reportDisplayName: report.reportDisplayName,
    dateRange: transformReportDateRangeModelToUI(
      report.startDate,
      report.endDate
    ),
  };
};
